<template>
  <div class="">
    <modal
      :show.sync="add"
      scrollable
      size="lg"
      header-classes="bg-primary p-3"
      body-classes="overflow-y-auto h65vh"
      @close="closeModal"
    >
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        ASSESSSMENT
      </h6>
      <div v-for="(item, ind) in assessments" :key="ind">
        <div class="px-4 pb-8 bg-ededed">
          <div class="headx flex justify-between items-center">
            <div>
              <p class="font-semibold text-2xl text-black">
                Assessment {{ ind + 1 }}
              </p>
            </div>
            <div>
              <feather-icon
                class="mx-2 cursor-pointer"
                icon="XIcon"
                svgClasses="w-6 h-6"
                @click="DeleteQue(ind)"
              ></feather-icon>
            </div>
          </div>
          <div class="question mt-2">
            <div class="w-full mb-4">
              <b-form>
                <base-input
                  v-model="item.question"
                  placeholder="Type Question"
                  class="w-full"
                  :rules="{ required: [true, 'Field is required'] }"
                ></base-input>
              </b-form>
            </div>
          </div>
          <div
            class="asnwers flex items-center mb-2"
            v-for="(answer, index) in item.answers"
            :key="index"
          >
            <div class="rounded-full">
              <!-- <feather-icon
            class=""
            icon="CircleIcon"
            svgClasses="w-3 h-3 text-primary"
          ></feather-icon> -->
              <b-form-radio
                v-model="item.correctAnswer"
                :name="'answer-question-' + ind + '-' + index"
                :value="item.answers[index].name"
              ></b-form-radio>
            </div>
            <!-- <p class="font-bold mr-2 text-lg">{{ letter[index] }}</p> -->
            <div class="w-full flex relative">
              <base-input
                :placeholder="`Option ${index + 1}`"
                v-model="item.answers[index].name"
                @focus="AddNewAnswer(ind, index)"
                class="w-full cusrpr"
                :rules="{ required: [true, 'Field is required'] }"
              ></base-input>

              <!-- <div class="bg-white absolute mr-2 right-12 top-1 divvert">
            <div class="active:bg-success p-2 mr-3  rounded-md">
              <feather-icon
                class="active:text-white"
                icon="CheckIcon"
                svgClasses="w-5 h-5 "
              ></feather-icon>
            </div>
            <div class="divvertmr-2"></div>
          </div> -->

              <div class="bg-white absolute right-2 top-1">
                <div class="active:bg-danger p-2 rounded-md">
                  <feather-icon
                    @click="DeleteAnswer(ind, index)"
                    class="active:text-white cursor-pointer"
                    icon="XIcon"
                    svgClasses="w-5 h-5"
                  ></feather-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full pl-2 pb-4">
          <p
            class="font-semibold text-sm hover:underline cursor-pointer"
            @click="AddNewQue(ind)"
          >
            New Question +
          </p>
        </div>
        <div class="mt-4">
          <p class="text-sm text-right font-normal">
            EXPLANATION OF CORRECT ANSWER
          </p>
          <textarea
            class="form-control mt-2"
            id="exampleFormControlTextarea3"
            v-model="item.explaination"
          ></textarea>
        </div>
      </div>
      <template slot="footer">
        <base-button type="primary" @click="handleSave()">SAVE</base-button>
        <base-button type="secondary" class="ml-auto" @click="closeModal"
          >CLOSE</base-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    addAssesment: Boolean,
    chapter: Object,
  },
  data() {
    return {
      assessments: [
        {
          question: "",
          answers: [
            { name: "", correctAns: false },
            { name: "", correctAns: false },
          ],
          correctAnswer: false,
          explaination: "",
        },
      ],
      letter: ["A", "B", "C", "D", "E", "F"],

      QueData: [],
    };
  },
  methods: {
    AddNewAnswer(ind, index) {
      if (
        this.assessments[ind].answers.length - 1 == index &&
        this.assessments[ind].answers.length < 4
      ) {
        this.assessments[ind].answers.push({ option: "", correctAns: false });
      }
    },
    DeleteAnswer(ind, index) {
      if ([0, 1].includes(index)) {
        return;
      }
      this.assessments[ind].answers = this.assessments[ind].answers.filter(
        (el, i) => i !== index
      );
    },
    AddNewQue(index) {
      this.assessments.push({
        question: "",
        answers: [
          { name: "", correctAns: false },
          { name: "", correctAns: false },
        ],
        correctAnswer: false,
        explaination: "",
      });
    },
    DeleteQue(index) {
      if ([0].includes(index)) {
        return;
      }
      this.assessments.splice(index, 1);
    },
    async handleSave() {
      this.assessments.forEach((assessment) => {
        assessment.answers.forEach((item) => {
          item.correctAns = assessment.correctAnswer === item.name;
        });
      });
      this.QueData = this.assessments.map((data) => ({
        question: data.question,
        explaination: data.explaination,
        option: data.answers,
      }));
      // console.log(this.QueData);
      const payload = {
        course: this.chapter.course[0],
        chapter: this.chapter._id,
        data: this.QueData,
      };
      // console.log(this.assessments);
      try {
        // const loader = this.$loading();
        if (this.assessments[0].question == "") {
          this.$swal.fire({
            title: "Warning!",
            text: "Please enter all fields",
            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          // } else if (this.assessments[0].explaination == "") {
        } else if (this.assessments[0].answers[0].name == "") {
          this.$swal.fire({
            title: "Warning!",
            text: "Please enter all fields",
            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          // } else if (this.assessments[0].answers[0].name == "") {
        } else if (this.assessments[0].explaination == "") {
          this.$swal.fire({
            title: "Warning!",
            text: "Please enter all fields",
            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
        } else {
          const data = await this.$store.dispatch(
            "eLearning/addQuestion",
            payload
          );
          if (data.code == 200) {
            await this.$store.dispatch("eLearning/getChapterByCourseId", {
              id: this.chapter.course[0],
            });

            this.$swal.fire({
              title: "Added",

              text: "Questions have been Added Successfully!",

              icon: "success",
              showConfirmButton: false,
              showCancelButton: false,
              timer: 2000,
            });
            // loader.close();
            this.closeModal();
          }
        }
      } catch (err) {
        // loader.close();
      }
      this.QueData = [];
      this.assessments = [
        {
          question: "",
          answers: [
            { name: "", correctAns: false },
            { name: "", correctAns: false },
          ],
          correctAnswer: "",
          explaination: "",
        },
      ];
    },
    closeModal() {
      this.$emit("close-addAssesment");
    },
  },
  computed: {
    add: {
      get() {
        return this.addAssesment;
      },
      set(val) {
        if (!val) {
          !this.closeModal();
        }
      },
    },
  },
};
</script>

<style>
.form-group {
  margin-bottom: 0px !important;
}
.divvert {
  border-right: 1px solid #ddd;
}
.cusrpr .form-control {
  padding-right: 7rem;
}
.custom-control-label::before {
  left: -2rem;
}
.custom-control-label::after {
  left: -2rem;
}
</style>
